import Vue from 'vue'
import Router from 'vue-router'
import Rating from 'components/Rating'
import ListBeers from 'components/ListBeers'
// import MyBeers from 'components/MyBeers'
import AddNew from 'components/AddNew'
import Facts from 'components/Facts'

Vue.use(Router)

export default new Router({
  // Removes hash tag from url
  mode: 'history',
  linkActiveClass: 'is-active',
  routes: [
    {
      path: '/',
      name: 'Rating',
      component: Rating
    },
    {
      path: '/list-beers',
      name: 'ListBeers',
      component: ListBeers
    },
    // {
    //   path: '/my-beers',
    //   name: 'MyBeers',
    //   component: MyBeers
    // },
    {
      path: '/facts',
      name: 'Facts',
      component: Facts
    },
    {
      path: '/add-new',
      name: 'AddNew',
      component: AddNew
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js